import { configureStore, combineReducers, AnyAction } from '@reduxjs/toolkit';
import * as reducers from './reducers';

const combinedReducer = combineReducers(reducers);

const rootReducer = (state: any, action: AnyAction) => {
  if (action.type === 'login-container/logout') {
    state = undefined;
  }
  return combinedReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
});
// 型定義
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
